import { RouterProvider } from "@tanstack/react-router"

import { router } from "./router"

// Deployment-batch develop smoke marker: keep this app in the test changeset.
function App() {
  return <RouterProvider router={router} />
}

export default App
